module.exports = __webpack_public_path__ + "images/feature/20161024_01-f3246bf3be6e0e2c7265873261436691.png";